import script from "./swiperTab.vue?vue&type=script&setup=true&lang=js"
export * from "./swiperTab.vue?vue&type=script&setup=true&lang=js"

import "./swiperTab.vue?vue&type=style&index=0&id=33866a2e&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-uk-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33866a2e"]])

export default __exports__